module.exports = __webpack_public_path__ + "static/img/case-glj-page-bg-04.14b53d3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case/glj/case-glj-page-bg-04.jpg
// module id = F0I1
// module chunks = 1